import { render, staticRenderFns } from "./Thrivent.vue?vue&type=template&id=cab20964&scoped=true&"
import script from "./Thrivent.vue?vue&type=script&lang=js&"
export * from "./Thrivent.vue?vue&type=script&lang=js&"
import style0 from "./Thrivent.vue?vue&type=style&index=0&id=cab20964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab20964",
  null
  
)

export default component.exports